/**
 * Foto e mbrojtur me token.
 *
 * `/api/assets/files/:id` kërkon `Authorization: Bearer …`, dhe një `<img src>`
 * nuk e dërgon dot atë kokë — foto do të kthehej 401 dhe do të dukej e prishur.
 * Prandaj skedari merret me `authFetch`, kthehet në `blob:` URL dhe vetëm ai i
 * jepet `<img>`-së. Endpoint-i mbetet i mbrojtur; asnjë token nuk shkon te URL,
 * ku do të përfundonte te historiku i shfletuesit dhe te log-et e serverit.
 */

import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import assetsService from '../../services/assetsService';
import { authFetch } from '../../services/apiServices';

export default function AuthImage({ fileId, alt = '', sx, radius = 2, fallbackIcon = true }) {
  const [url, setUrl] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!fileId) { setUrl(''); return undefined; }
    let alive = true;
    let objectUrl = '';
    (async () => {
      try {
        const res = await authFetch(assetsService.fileUrl(fileId, true));
        if (!res.ok) throw new Error(String(res.status));
        const blob = await res.blob();
        if (!alive) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch {
        if (alive) setFailed(true);
      }
    })();
    // Pa revoke, çdo rirenderim i listës lë prapa një blob në memorie.
    return () => { alive = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId]);

  if (url) {
    return (
      <Box component="img" src={url} alt={alt}
        sx={{ objectFit: 'cover', borderRadius: radius, display: 'block', ...sx }} />
    );
  }

  if (!fallbackIcon) return null;
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      bgcolor: 'grey.100', color: 'text.disabled', borderRadius: radius, ...sx,
    }}>
      <ImageOutlinedIcon sx={{ fontSize: 20, opacity: failed ? 0.4 : 0.7 }} />
    </Box>
  );
}
